import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6fe2a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-page" }
const _hoisted_2 = { class: "operation ws_mb24" }

import { ref, onMounted } from 'vue'
import ModelForm from './components/model-form-drawer.vue'
import { queryDeviceThingPage, deviceThingInfoDelete } from '@/api'
import { CODE_ENUM, PAGE_SIZES, MODEL_TYPE } from '@/common'
import moment from 'moment'
import OperationButtonList from '@/components/operation-button-list'
import { useRoute } from 'vue-router'
import { msgbox } from '@/utils'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const $route = useRoute()

const ops = [
  {
    label: '属性',
    value: MODEL_TYPE.PROPERTIES,
  },
  {
    label: '方法',
    value: MODEL_TYPE.ACTIONS,
  },
  {
    label: '事件',
    value: MODEL_TYPE.EVENTS,
  },
]

const thingModelId = $route.query.id || ''

const buttonList = ref([
  {
    type: 'edit',
    text: '编辑',
  },
  {
    type: 'delete',
    text: '删除',
  },
])

const col: any = ref([
  {
    prop: 'thingTypeValue',
    label: '功能类型',
  },
  {
    prop: 'name',
    label: '功能名称',
  },
  {
    prop: 'code',
    label: '标识符',
  },
  {
    prop: 'createDate',
    label: '创建时间',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
])

const formData = ref({
  thingType: '',
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableData: any = ref([])
const tableLoading = ref(false)

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryDeviceThingPage({
    ...formData.value,
    ...pageParams.value,
    thingModelId: Number(thingModelId),
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const modelConf = ref({
  visible: false,
  data: {},
})

const modelFrom = (data?: any) => {
  modelConf.value = {
    visible: true,
    data,
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: '你确定要删除这个物模型吗？',
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async (data: any) => {
  const res: any = await deviceThingInfoDelete(data)
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('操作成功')
  }

  fetchList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          onChange: fetchList,
          clearable: "",
          modelValue: formData.value.thingType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.thingType) = $event)),
          placeholder: "请选择功能类型",
          style: {"width":"280px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ops, (item) => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          onClick: modelFrom,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增")
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: item.prop
            }, { ...item }, { "show-overflow-tooltip": "" }), null, 16))
          }), 128)),
          _createVNode(_component_el_table_column, {
            width: 200,
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: buttonList.value,
                scope: scope.row,
                onOnDelete: toDelete,
                onOnEdit: modelFrom
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(ModelForm, {
      visible: modelConf.value.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((modelConf.value.visible) = $event)),
      data: modelConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})